// Другие форматы протокола — за стрелкой у PDF, как у расшифровки (решение
// владельца 02.10.2026: «как минимум Markdown и TXT»). Протокол и так хранится
// в markdown, поэтому .md — это текст как есть, а .txt — тот же текст без
// разметки: его читают в блокноте и вставляют в письмо, где «**» и «|---|»
// только мешают.

export const PROTOCOL_FORMATS = [
  { key: 'md', label: 'Текст с разметкой', ext: 'md', mime: 'text/markdown;charset=utf-8' },
  { key: 'txt', label: 'Простой текст', ext: 'txt', mime: 'text/plain;charset=utf-8' },
];

const TABLE_SEPARATOR = /^[ \t]{0,3}\|?[ \t]*:?-+:?[ \t]*(\|[ \t]*:?-+:?[ \t]*)*\|?[ \t]*$/;
const RULE = /^[ \t]{0,3}([-*_])([ \t]*\1){2,}[ \t]*$/;
// Буквы, внутри которых «__» и «*» — часть слова, а не выделение (\w кириллицы не знает).
const WORD = 'A-Za-z0-9_А-Яа-яЁё';

// Ячейки строки таблицы: «| а | б |» → ['а', 'б']. Экранированная «\|» — часть
// текста ячейки, а не граница. Без lookbehind в регулярках: Safari до 16.4 его не
// знает, и синтаксическая ошибка уронила бы весь бандл, а не одну выгрузку.
const PIPE = '\u0000';
function tableCells(line) {
  const cells = line.trim().split('\\|').join(PIPE)
    .replace(/^\|/, '').replace(/\|$/, '').split('|');
  return cells.map((c) => c.split(PIPE).join('|').trim());
}

function inline(text) {
  return text
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\(([^)\s]+)(?:\s[^)]*)?\)/g, (m, label, url) => (label === url ? url : `${label} (${url})`))
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\*\*(?=\S)([\s\S]*?\S)\*\*/g, '$1')
    .replace(new RegExp(`(^|[^${WORD}])__(?=\\S)([\\s\\S]*?\\S)__(?![${WORD}])`, 'g'), '$1$2')
    .replace(new RegExp(`(^|[^*${WORD}])\\*(?=\\S)([^*]*?\\S)\\*(?![*${WORD}])`, 'g'), '$1$2')
    .replace(/~~(?=\S)([\s\S]*?\S)~~/g, '$1')
    .replace(/\\([\\`*_{}[\]()#+\-.!|>~])/g, '$1');
}

/** Markdown протокола → простой текст: без заголовочных «#», выделения, таблиц-«|». */
export function protocolPlainText(markdown) {
  const out = [];
  let fenced = false;
  for (const raw of String(markdown || '').replace(/\r\n?/g, '\n').split('\n')) {
    if (/^\s*(```|~~~)/.test(raw)) { fenced = !fenced; continue; }
    if (fenced) { out.push(raw); continue; }
    if (RULE.test(raw)) { out.push(''); continue; }
    if (TABLE_SEPARATOR.test(raw) && raw.includes('-') && raw.includes('|')) continue;
    let line = raw;
    if (/^[ \t]{0,3}\|.*\|[ \t]*$/.test(line)) {
      out.push(tableCells(line).map(inline).join('\t'));
      continue;
    }
    const heading = line.match(/^ {0,3}#{1,6}[ \t]+/);
    if (heading) line = line.slice(heading[0].length).replace(/[ \t]+#+[ \t]*$/, '');
    line = line.replace(/^([ \t]{0,40})>[ \t]?/, '$1');
    line = line.replace(/^([ \t]{0,40})[-*+][ \t]+\[[ xX]\][ \t]+/, '$1• ');
    line = line.replace(/^([ \t]{0,40})[-*+][ \t]+/, '$1• ');
    out.push(inline(line));
  }
  const text = out.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  return text ? `${text}\n` : '';
}

/** Файл выбранного формата: { content, ext, mime }. */
export function buildProtocolExport(key, markdown) {
  const format = PROTOCOL_FORMATS.find((f) => f.key === key);
  if (!format) throw new Error(`Неизвестный формат протокола: ${key}`);
  const content = key === 'md' ? String(markdown || '') : protocolPlainText(markdown);
  return { content, ext: format.ext, mime: format.mime };
}
